import { Box, Container, Typography, styled } from '@mui/material';
import React from 'react';

import { Edit05Icon } from '@/assets/icons/Edit05Icon';
import { FaceHappyIcon } from '@/assets/icons/FaceHappyIcon';
import { ZapIcon } from '@/assets/icons/ZapIcon';

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.common.white,
}));

const SectionHeading = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif',
  fontWeight: 600,
  fontSize: '2.25rem',
  color: '#181D27',
  textAlign: 'center',
  marginBottom: theme.spacing(1),
}));

const SubHeading = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 600,
  color: theme.palette.primary.main,
  textAlign: 'center',
  marginBottom: theme.spacing(1),
}));

const SectionDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  color: '#535862',
  textAlign: 'center',
  maxWidth: '800px',
  margin: '0 auto',
  marginBottom: theme.spacing(6),
}));

const ValueCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 3),
  borderRadius: theme.spacing(2),
  backgroundColor: 'rgba(255, 244, 243, 0.5)',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: '56px',
  height: '56px',
  borderRadius: '10px',
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
}));

const ValueTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif',
  fontWeight: 500,
  fontSize: '1.25rem',
  color: '#181D27',
  marginBottom: theme.spacing(1),
}));

const ValueDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#535862',
}));

const values = [
  {
    Icon: Edit05Icon,
    title: 'Innovation',
    description: 'Continuously pushing boundaries to deliver cutting-edge solutions',
  },
  {
    Icon: FaceHappyIcon,
    title: 'Reliability',
    description: 'Building trust through consistent, dependable service',
  },
  {
    Icon: ZapIcon,
    title: 'Simplicity',
    description: 'Making complex property management tasks effortlessly manageable',
  },
];

const OurValuesSection: React.FC = () => (
  <SectionWrapper>
    <Container maxWidth="lg">
      <Box sx={{ mb: 6 }}>
        <SubHeading>What we stand for</SubHeading>
        <SectionHeading>Our Values</SectionHeading>
        <SectionDescription>
          The principles driving Terr.ai: innovative solutions, dependable performance, and
          effortless simplicity.
        </SectionDescription>
      </Box>

      <Box
        sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 3 }}
      >
        {values.map(value => (
          <Box key={value.title}>
            <ValueCard>
              <IconContainer>
                <value.Icon />
              </IconContainer>

              <Box>
                <ValueTitle>{value.title}</ValueTitle>
                <ValueDescription>{value.description}</ValueDescription>
              </Box>
            </ValueCard>
          </Box>
        ))}
      </Box>
    </Container>
  </SectionWrapper>
);

export default OurValuesSection;
